import { useEffect, useState } from "react";
import GlobalHeader from "@/components/GlobalHeader";
import axios from "axios";
import { BACKEND_URL, API } from "@/lib/api";


export default function AGB() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(`${API}/auth/session`, { withCredentials: true });
        if (response.data.user) {
          setUser(response.data.user);
        }
      } catch {
        // Not logged in
      }
    };
    checkSession();
  }, []);

  const handleLogin = () => {
    window.location.href = `${API}/auth/login`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex flex-col">
      {/* Global Header */}
      <GlobalHeader user={user} onLogin={handleLogin} showDashboard={true} />

      {/* Content - mit Padding für fixed Header */}
      <main className="flex-1 pt-20 pb-12">
        <div className="max-w-4xl mx-auto px-4 py-8">
          {/* Page Title */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Allgemeine Geschäftsbedingungen</h1>
            <p className="text-gray-500 mt-2">mokiplaner.com - Ihre Event-Management-Plattform</p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">

            <section>
              <h2 className="text-2xl font-bold mb-4">§1 Geltungsbereich</h2>
              <p className="text-gray-700 leading-relaxed">
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen mokiplaner.com
                (nachfolgend &quot;Anbieter&quot;) und dem Nutzer (nachfolgend &quot;Kunde&quot;) über die Nutzung der
                Event-Management-Plattform mokiplaner.com.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§2 Vertragsgegenstand</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  Der Anbieter stellt dem Kunden eine Online-Plattform zur Planung und Verwaltung von
                  Events zur Verfügung. Die Plattform ermöglicht:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Erstellung und Verwaltung von Events</li>
                  <li>Gästeverwaltung und RSVP-Funktionen</li>
                  <li>Upload von Fotos, Videos und Musik</li>
                  <li>Kommunikation mit Gästen via Chat</li>
                  <li>Teilen von Event-Informationen</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§3 Registrierung und Nutzerkonto</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  3.1 Die Nutzung der Plattform erfordert eine Registrierung. Der Kunde versichert,
                  dass alle bei der Registrierung angegebenen Daten vollständig und korrekt sind.
                </p>
                <p>
                  3.2 Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten und vor dem
                  Zugriff Dritter zu schützen.
                </p>
                <p>
                  3.3 Der Kunde ist für alle Aktivitäten verantwortlich, die unter seinem Konto
                  vorgenommen werden.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§4 Leistungen und Pakete</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  4.1 Der Anbieter bietet verschiedene Leistungspakete an (FREE, PREMIUM, PRO Abo, BUSINESS).
                  Der Umfang der Leistungen ergibt sich aus der jeweiligen Paketbeschreibung.
                </p>
                <p>
                  4.2 Kostenlose Pakete können jederzeit ohne Angabe von Gründen gekündigt werden.
                </p>
                <p>
                  4.3 Der Anbieter behält sich vor, den Funktionsumfang der Plattform jederzeit
                  zu erweitern oder anzupassen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§5 Preise und Zahlung</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  5.1 Die aktuellen Preise sind auf der Webseite einsehbar. Alle Preise verstehen
                  sich inklusive der gesetzlichen Mehrwertsteuer.
                </p>
                <p>
                  5.2 Die Zahlung erfolgt im Voraus über die angebotenen Zahlungsmethoden
                  (Kreditkarte, SEPA-Lastschrift, PayPal).
                </p>
                <p>
                  5.3 Bei Abonnements erfolgt die Abbuchung zu Beginn jeder Abrechnungsperiode.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§6 Nutzungsrechte und Inhalte</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  6.1 Der Kunde erhält ein nicht-exklusives, nicht übertragbares Nutzungsrecht
                  an der Plattform für die Dauer des Vertragsverhältnisses.
                </p>
                <p>
                  6.2 Der Kunde ist für alle von ihm hochgeladenen Inhalte selbst verantwortlich
                  und garantiert, dass diese keine Rechte Dritter verletzen.
                </p>
                <p>
                  6.3 Verboten ist das Hochladen von rechtswidrigen, beleidigenden,
                  diskriminierenden oder pornografischen Inhalten.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§7 Haftung</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  7.1 Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens,
                  des Körpers oder der Gesundheit.
                </p>
                <p>
                  7.2 Für sonstige Schäden haftet der Anbieter nur bei Vorsatz oder grober Fahrlässigkeit.
                </p>
                <p>
                  7.3 Der Anbieter übernimmt keine Garantie für die ständige Verfügbarkeit der Plattform.
                </p>
                <p>
                  7.4 Für von Nutzern hochgeladene Inhalte übernimmt der Anbieter keine Haftung.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§8 Datenschutz</h2>
              <p className="text-gray-700 leading-relaxed">
                Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung,
                die unter &quot;Datenschutz&quot; einsehbar ist. Der Kunde stimmt der Verarbeitung seiner Daten
                im Rahmen der Nutzung der Plattform zu.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§9 Kündigung</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  9.1 Kostenlose Pakete können jederzeit ohne Angabe von Gründen gekündigt werden.
                </p>
                <p>
                  9.2 Abonnements können zum Ende der jeweiligen Abrechnungsperiode gekündigt werden.
                </p>
                <p>
                  9.3 Der Anbieter behält sich das Recht vor, bei Verstößen gegen diese AGB das
                  Nutzerkonto zu sperren oder zu löschen.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§10 Änderungen der AGB</h2>
              <p className="text-gray-700 leading-relaxed">
                Der Anbieter behält sich vor, diese AGB jederzeit zu ändern. Über wesentliche Änderungen
                werden registrierte Kunden per E-Mail informiert. Die weitere Nutzung nach Inkrafttreten
                der Änderungen gilt als Zustimmung.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">§11 Schlussbestimmungen</h2>
              <div className="text-gray-700 leading-relaxed space-y-3">
                <p>
                  11.1 Es gilt das Recht der Bundesrepublik Deutschland.
                </p>
                <p>
                  11.2 Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit
                  der übrigen Bestimmungen unberührt.
                </p>
                <p>
                  11.3 Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters.
                </p>
              </div>
            </section>

            <div className="pt-8 border-t mt-8">
              <p className="text-sm text-gray-500">Stand: Februar 2026</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
